import Button from '@atlaskit/button';
import Heading from '@atlaskit/heading';
import { Box, Stack, xcss } from '@atlaskit/primitives';
import React, { type FunctionComponent, type ReactNode } from 'react';

export interface CompactEmptyStateProps {
  imageUrl: string;
  heading: string;
  description: ReactNode;
  buttonText?: string;
  onButtonClick?: () => void;
}

const CompactEmptyState: FunctionComponent<CompactEmptyStateProps> = ({
  imageUrl,
  heading,
  description,
  buttonText,
  onButtonClick,
}) => {
  return (
    <Stack
      alignBlock="center"
      alignInline="center"
      space="space.150"
      xcss={xcss({
        textAlign: 'center',
        paddingTop: 'space.800',
        paddingBottom: 'space.800',
      })}
    >
      <img src={imageUrl} role="presentation" />
      <Heading as="h2" size="medium">
        {heading}
      </Heading>
      <Box
        xcss={xcss({
          width: '277px',
          // @remark: Disabled as part of https://bitbucket.org/atlassian/canvas/pull-requests/27504/overview,
          // this should be re-enabled as soon as feasible
          // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
          lineHeight: '24px',
        })}
      >
        {description}
      </Box>
      {buttonText && onButtonClick && (
        <Button appearance="primary" onClick={onButtonClick}>
          {buttonText}
        </Button>
      )}
    </Stack>
  );
};

export default CompactEmptyState;
